exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".privacy-policy-page[data-v-e0e06310]{padding:20px}", ""]);

// exports
